'use client';

import { LoadingSpinner } from './LoadingSpinner';
import { cn } from '@/shared/lib/cn';

interface InlineLoadingProps {
  isLoading: boolean;
  text?: string;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export function InlineLoading({
  isLoading,
  text = 'Loading...',
  size = 'sm',
  className = '',
}: InlineLoadingProps) {
  if (!isLoading) return null;

  const textSizeClasses = {
    xs: 'text-card-meta',
    sm: 'text-list-item-subtitle',
    md: 'text-card-body',
  };

  return (
    <div
      className={cn(
        'inline-flex items-center text-muted-foreground',
        className
      )}
    >
      <LoadingSpinner size={size} className="mr-2" />
      <span className={textSizeClasses[size]}>{text}</span>
    </div>
  );
}

// For showing loading state next to form labels
export function FormFieldLoading({
  isLoading,
  text = 'Checking...',
}: {
  isLoading: boolean;
  text?: string;
}) {
  if (!isLoading) return null;

  return (
    <span className="ml-2 inline-flex items-center text-card-meta text-muted-foreground">
      <LoadingSpinner size="xs" className="mr-1" />
      {text}
    </span>
  );
}

// For showing loading state in select/dropdown options
export function OptionLoading({
  text = 'Loading options...',
}: {
  text?: string;
}) {
  return (
    <div className="px-4 py-2 text-list-item-subtitle text-muted-foreground">
      <InlineLoading isLoading={true} text={text} size="sm" />
    </div>
  );
}
